import { Outlet, useNavigation } from "react-router-dom";
import Menu from "../components/Menu";

function RootLayout() {
    const navigation = useNavigation();
    return (
        <>
            <Menu/>
            <main>
                {navigation.state === 'loading' ? "Loading ..." : undefined}
                <Outlet/>
            </main>
        </>
    )
}

export default RootLayout;